import { type FC } from "react";

import { type BlackboardInstance } from "../blackboardModels";
import { InfoRow } from "./InfoRow";

// ---------------------------------------------------------------------------
// ProvenanceSection — who/when: display name, created, spawned-by. The
// instance id is surfaced in RuntimeSection (it pairs with the run + token
// facts); this section is purely the "what is this actor" provenance.
// ---------------------------------------------------------------------------

export const ProvenanceSection: FC<{ instance: BlackboardInstance }> = ({
  instance,
}) => (
  <>
    <InfoRow label="Name">
      <span className="text-sm font-medium text-slate-900 dark:text-white">
        {instance.displayName}
      </span>
    </InfoRow>
    <InfoRow label="Created">
      <span className="font-mono text-[11px] text-slate-500 dark:text-slate-400">
        {new Date(instance.createdAt).toLocaleString()}
      </span>
    </InfoRow>
    {instance.spawnedBy && (
      <InfoRow label="Spawned By">
        <span className="font-mono text-[11px] text-slate-500 dark:text-slate-400">
          {instance.spawnedBy}
        </span>
      </InfoRow>
    )}
  </>
);
